import React from "react";
import { useNavigate } from "react-router-dom";
import logoF from "../img/logo.png";
import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();

  const irA = (ruta) => {
    navigate(ruta);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="gj-footer">
      {/* =========================================================
          SECCIÓN PRINCIPAL
      ========================================================= */}
      <div className="gj-footer-main">
        <div className="gj-footer-container">
          <div className="gj-footer-grid">
            {/* =====================================================
                EMPRESA
            ===================================================== */}
            <div className="gj-footer-company">
              <button
                type="button"
                className="gj-footer-logo"
                onClick={() => irA("/")}
                aria-label="Ir al inicio"
              >
                <img src={logoF} alt="G&J Frío Industrial y Doméstico" />
              </button>

              <h3>G&J Frío Industrial y Doméstico</h3>

              <p className="gj-footer-description">
                Soluciones en refrigeración industrial y doméstica, línea
                blanca, aire acondicionado e instalaciones.
              </p>

              <div className="gj-footer-company-badge">
                <i className="bi bi-patch-check-fill"></i>

                <span>Calidad y servicio técnico</span>
              </div>
            </div>

            {/* =====================================================
                ENLACES
            ===================================================== */}
            <div className="gj-footer-column">
              <h4>Enlaces rápidos</h4>

              <div className="gj-footer-title-line"></div>

              <ul className="gj-footer-links">
                <li>
                  <button type="button" onClick={() => irA("/")}>
                    <i className="bi bi-house-door"></i>
                    <span>Inicio</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/industrialr")}>
                    <i className="bi bi-box-seam"></i>
                    <span>Productos</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/quienes")}>
                    <i className="bi bi-people"></i>
                    <span>Nosotros</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/ayuda")}>
                    <i className="bi bi-question-circle"></i>
                    <span>Ayuda</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/envios")}>
                    <i className="bi bi-truck"></i>
                    <span>Envíos</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/garantias")}>
                    <i className="bi bi-shield-check"></i>
                    <span>Garantías y devoluciones</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/contacto")}>
                    <i className="bi bi-envelope"></i>
                    <span>Contáctanos</span>
                  </button>
                </li>
              </ul>
            </div>

            {/* =====================================================
                CATEGORÍAS
            ===================================================== */}
            <div className="gj-footer-column">
              <h4>Categorías</h4>

              <div className="gj-footer-title-line"></div>

              <ul className="gj-footer-links">
                <li>
                  <button type="button" onClick={() => irA("/industrialr")}>
                    <i className="bi bi-snow"></i>
                    <span>Refrigeración Industrial</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/nevera")}>
                    <i className="bi bi-house-gear"></i>
                    <span>Refrigeración Doméstica</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/lavadora")}>
                    <i className="bi bi-arrow-repeat"></i>
                    <span>Lavadoras</span>
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    onClick={() => irA("/aireacondicionado")}
                  >
                    <i className="bi bi-wind"></i>
                    <span>Aire Acondicionado</span>
                  </button>
                </li>

                <li>
                  <button type="button" onClick={() => irA("/gas")}>
                    <i className="bi bi-fire"></i>
                    <span>Instalaciones a Gas</span>
                  </button>
                </li>
              </ul>
            </div>

            {/* =====================================================
                CONTACTO
            ===================================================== */}
            <div className="gj-footer-column gj-footer-contact-column">
              <h4>Contáctanos</h4>

              <div className="gj-footer-title-line"></div>

              <ul className="gj-footer-contact-list">
                <li>
                  <span className="gj-footer-contact-icon">
                    <i className="bi bi-geo-alt-fill"></i>
                  </span>

                  <div>
                    <strong>Dirección</strong>

                    <span>
                      Machala - Junín E/ Marcel Laniado y Kleber Franco.
                    </span>
                  </div>
                </li>

                <li>
                  <span className="gj-footer-contact-icon">
                    <i className="bi bi-telephone-fill"></i>
                  </span>

                  <div>
                    <strong>Teléfonos</strong>

                    <div className="gj-footer-phone-list">
                      <a href="tel:+593939979333">0939979333</a>

                      <span>-</span>

                      <a href="tel:+593993903605">0981443171</a>
                    </div>
                  </div>
                </li>

                <li>
                  <span className="gj-footer-contact-icon">
                    <i className="bi bi-envelope-fill"></i>
                  </span>

                  <div>
                    <strong>Correo electrónico</strong>

                    <a href="mailto:gonzaloivanal@gmail.com">
                      gonzaloivanal@gmail.com
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* =====================================================
              HORARIOS
          ===================================================== */}
          <div className="gj-footer-schedule">
            <div className="gj-footer-schedule-title">
              <span>
                <i className="bi bi-clock-fill"></i>
              </span>

              <div>
                <strong>Horarios de atención</strong>
                <small>Estamos disponibles durante toda la semana</small>
              </div>
            </div>

            <div className="gj-footer-schedule-grid">
              <div className="gj-schedule-item">
                <span>Lunes - Viernes</span>
                <strong>8:00 AM - 6:00 PM</strong>
              </div>

              <div className="gj-schedule-item">
                <span>Sábados</span>
                <strong>8:00 AM - 5:00 PM</strong>
              </div>

              <div className="gj-schedule-item">
                <span>Domingos</span>
                <strong>8:00 AM - 1:00 PM</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =========================================================
          REDES SOCIALES
      ========================================================= */}
      <div className="gj-footer-social-section">
        <div className="gj-footer-container gj-footer-social-container">
          <div className="gj-footer-social-text">
            <span className="gj-footer-social-icon">
              <i className="bi bi-share-fill"></i>
            </span>

            <div>
              <strong>Síguenos en nuestras redes</strong>

              <small>Conoce nuestros productos, novedades y servicios.</small>
            </div>
          </div>

          <div className="gj-footer-socials">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gj-social-button"
              aria-label="Facebook"
              title="Facebook"
            >
              <i className="bi bi-facebook"></i>
            </a>

            <a
              href="https://www.instagram.com/gjfrioindustrial/"
              target="_blank"
              rel="noopener noreferrer"
              className="gj-social-button"
              aria-label="Instagram"
              title="Instagram"
            >
              <i className="bi bi-instagram"></i>
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gj-social-button"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <i className="bi bi-linkedin"></i>
            </a>

            <a
              href="https://x.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gj-social-button"
              aria-label="X"
              title="X"
            >
              <i className="bi bi-twitter-x"></i>
            </a>
          </div>
        </div>
      </div>

      {/* =========================================================
          COPYRIGHT
      ========================================================= */}
      <div className="gj-footer-bottom">
        <div className="gj-footer-container gj-footer-bottom-container">
          <p>
            © {currentYear} <strong>G&J Frío Industrial y Doméstico</strong>.
            Todos los derechos reservados.
          </p>

          <p className="gj-footer-developer">
            Desarrollado por <strong>Ing. David Paz</strong>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
